import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { startVersionCheck } from "./common/versionCheck";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
// import store, { history } from './store';
import { history } from "./store";

import "./config/fontAwesome";
import "bootstrap/dist/css/bootstrap.min.css";
import "./common/styles.css";

import { PersistGate } from "redux-persist/integration/react";
import storeAndPersistorReturner from "./store";

const { store, persistor } = storeAndPersistorReturner();
console.log("index js. v6.1.0");
const app = (
  <Provider store={store}>
    <PersistGate loading={<div>Yükleniyor ...</div>} persistor={persistor}>
      <ConnectedRouter history={history}>
        <div>
          <App />
        </div>
      </ConnectedRouter>
    </PersistGate>
  </Provider>
);

const SW_CLEANUP_FLAG = "sw_cleanup_done_v1";

if (
  "serviceWorker" in navigator &&
  navigator.serviceWorker.controller &&
  !sessionStorage.getItem(SW_CLEANUP_FLAG)
) {
  // A stale service worker from a past deploy is controlling this page load,
  // serving an outdated cached bundle mismatched with the current build
  // (causes a blank screen until the next, uncontrolled, reload). Clear it
  // out and force a single reload instead of rendering onto a broken cache.
  sessionStorage.setItem(SW_CLEANUP_FLAG, "1");
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    Promise.all(registrations.map((registration) => registration.unregister())).then(
      () => {
        if (window.caches) {
          caches.keys().then((names) => {
            Promise.all(names.map((name) => caches.delete(name))).finally(() =>
              window.location.reload()
            );
          });
        } else {
          window.location.reload();
        }
      }
    );
  });
} else {
  ReactDOM.render(app, document.getElementById("root"));
  startVersionCheck({ history, persistor });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
